const LangProfile = {
	"profile.title": ["MY PROFILE", "ប្រវត្តិរូប​​​ខ្ញុំ"],
	"profile.subTitle.personalInformation": [
		"PERSONAL INFORMATION",
		"ព័ត៌មាន​ផ្ទាល់​ខ្លួន",
	],
	"profile.subTitle.addressInformation": [
		"ADDRESS INFORMATION",
		"ព័ត៌មាន​អំពី​អាសយដ្ឋាន",
	],
	"profile.link.changePassword": ["Change my password", "ប្តូរ​លេខ​សម្ងាត់"],
	"profile.link.unregisterAccount": [
		"Click here if you want to unregister your account.",
		"ចុច​ត្រង់​នេះ​ ប្រសិន​បើ​លោក​អ្នក​ចង់​លុប​គណនី​​​ចោល",
	],
}

export default LangProfile



// WEBPACK FOOTER //
// ./src/resources/pages/LangProfile.js